import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballPlayerService } from "../../../../../commons";
import { FootballBasicStatistics } from "../../../../../commons/models/football/football-basic-statistics";
import { StatusEnum } from "../../../../../commons/enums/status-enum";

export interface IFootballPlayerStatisticsState {
  playerStatistics: FootballBasicStatistics;
  playerStatisticsStatus: StatusEnum;
}

export interface IFootballPlayerStatisticsOption {
  playerId: number;
  urlParams?: {
    seasonId?: number;
  };
}

const initialState: IFootballPlayerStatisticsState = {
  playerStatistics: new FootballBasicStatistics(),
  playerStatisticsStatus: StatusEnum.Idle,
};

export const fetchManagePlayerBasicStatistics = createAsyncThunk(
  "players/fetchManagePlayerBasicStatistics",
  async (options: IFootballPlayerStatisticsOption, thunkAPI) => {
    try {
      const playerStatistics = await manageFootballPlayerService.getStatistics(options.playerId, options.urlParams);
      return playerStatistics;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManagePlayerStatisticsSlice = createSlice({
  name: "footballManagePlayerStatistics",
  initialState: initialState,
  reducers: {
    cleanUpManagePlayerStats(state) {
      state.playerStatistics = new FootballBasicStatistics();
      state.playerStatisticsStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManagePlayerBasicStatistics.pending, (state) => {
        state.playerStatisticsStatus = StatusEnum.Loading;
      })
      .addCase(fetchManagePlayerBasicStatistics.fulfilled, (state, action: PayloadAction<FootballBasicStatistics>) => {
        state.playerStatisticsStatus = StatusEnum.Succeeded;
        state.playerStatistics = action.payload;
      })
      .addCase(fetchManagePlayerBasicStatistics.rejected, (state) => {
        state.playerStatisticsStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpManagePlayerStats } = footballManagePlayerStatisticsSlice.actions;
export default footballManagePlayerStatisticsSlice.reducer;
